<template>
  <v-dialog :value="value" persistent width="800" @click:outside="close()">
    <v-card>
      <v-card-title class="pl-5 pr-2 pt-4 pb-2">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        <div class="title h6">
          TPR/EDLC Alignment Warning
        </div>
        <v-card-subtitle class="pa-0 my-2" style="word-break: break-word;">
          {{ `${billing_mode} promotions were detected that overlap this promotion but do not share the same start and/or end dates.` }}<br>
          <strong>{{ `Please ensure that ${billing_mode} promotions intended to stack have matching start and end dates.` }}</strong> Continue?
        </v-card-subtitle>
      </v-card-title>
      <v-divider class="mx-4"/>
      <v-container fluid class="pa-0">
        <v-data-table
          class="mx-4"
          :headers="headers"
          :items="misalignedPromos"
          dense
          :height="tableHeight"
          fixed-header
          disable-pagination
          :footer-props="{'items-per-page-options': [-1]}"
          :items-per-page="-1">
          <template v-slot:[`item.promo_number`]="{ item }">
            <router-link class="primary--text" style="text-decoration:none;" :to="{ path: `/promo?id=${item.promo_id}`}" target="_blank">
              {{ item.promo_number }}
            </router-link>
          </template>
          <template v-slot:[`item.start_dt`]="{ item }">
            <span v-if="item.end_dt">{{$config.formatDate(item.start_dt)}}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:[`item.end_dt`]="{ item }">
            <span v-if="item.end_dt">{{$config.formatDate(item.end_dt)}}</span>
            <span v-else>-</span>
          </template>
        </v-data-table>
        <div class="d-flex justify-center">
          <v-btn class="mb-4 mr-4" text @click="close()">
            Cancel
          </v-btn>
          <v-btn class="mb-4" color="warning" @click="submitMisalignedTPR">
            Submit
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'TPRAlignmentAlertModal',
  props: {
    value: Boolean,
    misalignedPromos: Array,
    promo: Object
  },
  data() {
    return {
      headerProps: {
        sortable: false,
        class: 'accent white--text'
      },
      baseHeaders: [
        { text: 'Promo Name', value: 'promo_name' },
        { text: 'Promo Number', value: 'promo_number' },
        { text: 'Promo Category', value: 'promo_category_name' },
        { text: 'Start Date', value: 'start_dt' },
        { text: 'End Date', value: 'end_dt' }
      ]
    }
  },
  computed: {
    headers () {
      return this.baseHeaders.map(header => {
        return { ...this.headerProps, ...header }
      })
    },
    tableHeight () {
      return this.misalignedPromos?.length >= 12 ? '384px' : undefined
    },
    billing_mode() {
      return this.promo?.billing_mode?.constant
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submitMisalignedTPR () {
      this.$emit('submitMisalignedTPR')
    }
  }
}
</script>
<style>
.header {
  color: white;
  background: #385F73;
}
.title {
  width: 73%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>